import { render } from "./GlobalSignatureSettings.vue?vue&type=template&id=1edfe4d9&scoped=true"
import script from "./GlobalSignatureSettings.vue?vue&type=script&lang=ts"
export * from "./GlobalSignatureSettings.vue?vue&type=script&lang=ts"

import "./GlobalSignatureSettings.vue?vue&type=style&index=0&id=1edfe4d9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1edfe4d9"

export default script